<template>
    <div class="background">
        <div class="login-container">
            <img src="logo.png" alt="Logo" class="logo"> <!-- 替换为您的Logo路径 -->
            <h2>公路路面沉降监测系统</h2>
            <form id="loginForm">
                <div>
                  <input type="text" v-model="username" placeholder="用户名" id="username" required>
                </div>
                <div>
                  <input type="password" v-model="password" placeholder="密码" id="password" required @keydown.enter="handleLogin">
                </div>
                <div>
                  <button type="button" @click="handleLogin">登录</button>
                </div>
            </form>
        </div>
    </div>
  </template>
  
  <script>
import api from '@/api/api';

  export default {
    data() {
      return {
        username: '',
        password: '',
      };
    },
    methods: {
      handleLogin() {
        const username = this.username;
        const password = this.password;
        if(!username || !password || username.trim() =="" || password.trim()=="") {
          this.$message({
            message:'用户名/密码不能为空',
            type:'warning'
          })
          return;
        }
        const hash = this.hash;
        api.post('/login',{
            username: username,
            password: password
        }).then(response => {
                const res = response.data.data;
                localStorage.setItem("token", res.token)
                localStorage.setItem("username", username)
                localStorage.setItem("userType", res.user_type)
                // 1: 管理员，2：普通用户
                if(res.user_type == 1) {
                  this.$router.push({ path: '/admin' });
                } else {
                  this.$router.push({ path: '/dashboard'})
                }
        },error => {
          this.$message({
                message: '登录失败',
                type: 'error'
              })
        })
        // 登录逻辑，成功后跳转到管理内页
      }
    },
    mounted () {
        const token = localStorage.getItem('token');
        const userType = localStorage.getItem('userType');
        if(token && userType == 1) {
            this.$router.push('/admin')
        } else {
          this.$router.push('/dashboard')
        }
    }
  };
  </script>
  
  <style scoped>
body, html {
    margin: 0;
    padding: 0;
    height: 100%;
}

.background {
    background-image: url('assets/background.jpg'); /* 替换为您的背景图片路径 */
    background-size: cover;
    background-position: center;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.login-container {
    background: rgba(255, 255, 255, 0.7);
    padding: 20px;
    border-radius: 5px;
    text-align: center;
}

.login-container img.logo {
    width: 150px; /* 根据需要调整Logo大小 */
    margin-bottom: 20px;
}

.login-container input {
    margin-bottom: 10px;
    width: 250px;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

.login-container button {
    width: 270px;
    padding: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.login-container button:hover {
    background-color: #0056b3;
}

  </style>
  